import Add from "@material-ui/icons/Add";
import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/UI/Button/Button";
import Input from "../../components/UI/Input/Input";
import Modal from "../../components/UI/Modal/Modal";
import Search from "../../components/UI/Search/Search";
import Spinner from "../../components/UI/Spinner/Spinner";
import Table from "../../components/UI/Table/Table";
import DecreaseCredit from "../../components/Unit/Operations/DecreaseCredit";
import RaiseCredit from "../../components/Unit/Operations/RaiseCredit";
import Transactions from "../../components/Unit/Transactions/Transactions";
import UnitForm from "../../components/Unit/UnitForm/UnitForm";
import FetchData from "../../shared/fetchData";
import { checkValidity, updateObject } from "../../shared/utility";
import "./Units.css";

const Units = () => {
  const [units, setUnits] = useState([]);
  const [searchParams, setSearchParams] = useState({
    unitName: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        // required: true
      },
      errorMessage: "فیلد الزامی است",
      valid: true,
      value: "",
    },
  });
  const [unitId, setUnitId] = useState("");
  const [rerender, setRerender] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [unit, setUnit] = useState("");
  const [loading, setLoading] = useState(false);
  const [newUnitPage, setNewUnitPage] = useState(false);
  const [view, setView] = useState(false);
  const [parents, setParents] = useState([]);
  const [modalContent, setModalContent] = useState("");
  const [permission] = useState(window.localStorage.getItem("permission"));
  const ref = useRef();
  useEffect(() => {
    setPageIndex(0);
    setPageSize(10);
    setPageCount(0);
    var info = {
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/units/getUnits";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setParents(result.units);
      })
      .catch((error) => console.log(error));
  }, []);

  const unitChangeState = (id) => {
    setUnitId(id);
    setModalContent(
      <div>
        <div className="row justify-content-center">
          آیا از تغییر وضعیت مطمئن هستید؟
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-6">
            <Button btnType="Success" clicked={() => ref.current.closeModal()}>
              خیر
            </Button>
          </div>
          <div className="col-6">
            <Button btnType="Success" clicked={() => unitChangeStateSubmit(id)}>
              بله
            </Button>
          </div>
        </div>
      </div>
    );
    ref.current.openModal();
  };
  const unitChangeStateSubmit = (id) => {
    var info = {
      unit: {
        id: id,
      },
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/units/changeUnitState";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "0") {
          ref.current.closeModal();
        }
        search();
      })
      .catch((error) => console.log(error));
  };

  const getData = (pagination, isRefresh) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setLoading(true);
    var raw =
      !!isRefresh && isRefresh
        ? JSON.stringify({
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          })
        : JSON.stringify({
            unit: {
              unitName:
                searchParams.unitName.value !== ""
                  ? searchParams.unitName.value
                  : null,
            },
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          });
    var url = "management/api/v1/units/getUnits";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          let newList = [];
          for (let i = 0; i < pagination.pageIndex * pagination.pageSize; i++) {
            newList.push([]);
          }
          newList = newList.concat(result.units);
          pushData(newList);
          setUnits(newList);
          setPageCount(result.count);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => setLoading(false));
  };
  const pushData = (data) => {
    const rows = [];
    const headers = [
      {
        accessorKey: "unitName",
        header: "نام سفارش دهنده",
        align: "center",
      },
      {
        accessorKey: "balance",
        header: "موجودی حساب",
        align: "center",
      },
      {
        accessorKey: "isActive",
        header: "وضعیت کاربر",
        align: "center",
      },
      {
        accessorKey: "enableFirstMile",
        header: "باندل جمع آوری",
        align: "center",
      },
      {
        accessorKey: "firstMileDiscount",
        header: "درصد تخفیف هزینه باندل جمع آوری",
        align: "center",
      },
      {
        accessorKey: "enableLastMile",
        header: "باندل تخلیه",
        align: "center",
      },
      {
        accessorKey: "lastMileDiscount",
        header: "درصد تخفیف هزینه باندل تخلیه",
        align: "center",
      },
    ];
    const buttons = [];
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    data.map((d) => {
      rows.push({
        id: d.id,
        unitName: d.unitName,
        balance:
          d.balance != null && d.balance != ""
            ? d.balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0",
        isActive:
          d.isActive != null && d.isActive == "1" ? "فعال است" : "فعال نیست",
        enableFirstMile:
          d.enableFirstMile != null && d.enableFirstMile == "1"
            ? "دارد"
            : "ندارد",
        firstMileDiscount: d.firstMileDiscount,
        enableLastMile:
          d.enableLastMile != null && d.enableLastMile == "1"
            ? "دارد"
            : "ندارد",
        lastMileDiscount: d.lastMileDiscount,
      });
    });
    buttons.push({ id: 1, text: "ویرایش", clicked: editUnit });
    buttons.push({ id: 2, text: "مشاهده", clicked: viewUnit });
    buttons.push({ id: 3, text: "افزایش اعتبار", clicked: raiseCredit });
    buttons.push({ id: 4, text: "کاهش اعتبار", clicked: decreaseCredit });
    buttons.push({
      id: 5,
      text: "ریز تراکنش مالی",
      clicked: financialTransactional,
    });
    buttons.push({ id: 6, text: "تغییر وضعیت", clicked: unitChangeState });
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    setRerender(!rerender);
  };
  const search = (event) => {
    getData({ pageIndex: pageIndex, pageSize: pageSize });
  };

  const inputChangedHandlerSearch = (event, controlName) => {
    if (controlName == "cellNumber" && event.target.value.length > 11) {
    } else {
      const updatedControls = updateObject(searchParams, {
        [controlName]: updateObject(searchParams[controlName], {
          value: event.target.value,
          valid: checkValidity(
            event.target.value,
            searchParams[controlName].validation
          ),
        }),
      });
      setSearchParams(updatedControls);
    }
  };
  const afterCloseModal = (event) => {};
  const raiseCredit = (id) => {
    setUnitId(id);
    setModalContent(
      <RaiseCredit
        unitId={id}
        closeModal={() => ref.current.closeModal()}
        reload={() => {
          ref.current.closeModal();
          search();
        }}
      />
    );
    ref.current.openModal();
  };
  const decreaseCredit = (id) => {
    setUnitId(id);
    setModalContent(
      <DecreaseCredit
        unitId={id}
        closeModal={() => ref.current.closeModal()}
        reload={() => {
          ref.current.closeModal();
          search();
        }}
      />
    );
    ref.current.openModal();
  };
  const financialTransactional = (id) => {
    setUnitId(id);
    setModalContent(
      <div className="TransactionModal">
        <Transactions unitId={id} back={() => ref.current.closeModal()} />
      </div>
    );
    ref.current.openModal();
  };
  const refresh = (event) => {
    const srch = searchParams;
    for (let key in srch) {
      srch[key].value = "";
    }
    setSearchParams(srch);
    getData({ pageIndex: pageIndex, pageSize: pageSize }, true);
  };
  const toggleNewUnitForm = (event, value) => {
    if (value == false) {
      search();
    }
    setNewUnitPage(value);
    setView(false);
  };

  const addNewUnitType = (event, id) => {
    setUnit("");
    setEdit(false);
    setNewUnitPage(true);
  };

  const editUnit = (id, data) => {
    const unt = data.filter((u) => u.id == id);
    if (unt != null && unt.length != 0) {
      setUnit(unt[0]);
      setEdit(true);
      setNewUnitPage(true);
    }
  };

  const viewUnit = (id, data) => {
    const unt = data.filter((u) => u.id == id);
    if (unt != null && unt.length != 0) {
      setUnit(unt[0]);
      setEdit(true);
      setNewUnitPage(true);
      setView(true);
    }
  };

  const formElementsArrayS = [];
  for (let key in searchParams) {
    formElementsArrayS.push({
      id: key,
      config: searchParams[key],
    });
  }
  let formS = formElementsArrayS.map((formElement) => {
    let className = "3 mt-3";
    if (formElement.id == "comment") {
      className = "12 mt-3";
    }
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        col={className}
        changed={(event) => inputChangedHandlerSearch(event, formElement.id)}
      />
    );
  });
  formS = (
    <div>
      <div className="row pl-4" dir="ltr" style={{ height: "0px" }}>
        <Button btnType="Refresh" clicked={refresh}></Button>
      </div>
      <div className="row small-acc-srch">{formS}</div>
      <div className="row pl-3 mt-3" dir="ltr">
        <Button btnType="Search" clicked={search}>
          جستجو
        </Button>
      </div>
    </div>
  );
  return (
    <div>
      {loading ? <Spinner /> : ""}
      {!newUnitPage ? (
        <div>
          <Search class="orders-search" form={formS} />
          {permission.includes != null && permission.includes("UNIT_WRITE") ? (
            <div className="row justify-content-center mt-3 ml-3">
              <div className="UserGeneralBtn mb-2">
                <div onClick={(event) => addNewUnitType(event)} className="Add">
                  <Add className="UserIcon" />
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {rerender ? (
            // <Spinner />
            <Table
              hasDetails={false}
              pageSize={pageSize}
              data={units}
              pageIndex={pageIndex}
              getData={getData}
              list={tableData}
              rowCount={pageCount}
              columnSize={200}
              loading={loading}
            />
          ) : (
            <Table
              hasDetails={false}
              pageSize={pageSize}
              data={units}
              pageIndex={pageIndex}
              getData={getData}
              list={tableData}
              rowCount={pageCount}
              columnSize={200}
              loading={loading}
            />
          )}
          <Modal
            content={modalContent}
            ref={ref}
            closePermission={true}
            closeModal={(event) => afterCloseModal(event)}
          />
        </div>
      ) : (
        <UnitForm
          toggleNewUnitForm={toggleNewUnitForm}
          view={view}
          edit={edit}
          units={parents}
          unit={unit}
        />
      )}
    </div>
  );
};

export default Units;
